import { Box, Typography } from '@mui/material'
import { aboutValues } from '../../data/aboutContent'
import FigmaIconFrame from '../common/FigmaIconFrame'
import { MOBILE_MQ, mobileBodyTextSx, mobileSectionTitleSx } from '../../theme/mobileLayout'
import { scale } from '../../theme/scale'

export default function AboutValuesSection() {
  return (
    <Box
      component="section"
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: { xs: 5, md: '80px' },
      }}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: { xs: 'column', lg: 'row' },
          gap: { xs: 3, md: 6, lg: '249px' },
          alignItems: 'flex-start',
        }}
      >
        <Typography
          component="h2"
          sx={{
            ...mobileSectionTitleSx,
            fontSize: { ...mobileSectionTitleSx.fontSize, lg: scale.fontSize.sectionTitle },
            lineHeight: 'normal',
            fontWeight: 400,
            color: '#111',
            maxWidth: 443,
            flexShrink: 0,
            [MOBILE_MQ]: { fontSize: 28 },
          }}
        >
          Building Better Communities
        </Typography>
        <Typography
          sx={{
            ...mobileBodyTextSx,
            lineHeight: 'normal',
            fontWeight: 400,
            color: '#111',
            maxWidth: 828,
          }}
        >
          Purpose-driven initiatives focused on humanity, leadership, and positive social
          transformation.
        </Typography>
      </Box>

      <Box
        sx={{
          display: 'grid',
          gridTemplateColumns: {
            xs: '1fr',
            md: 'repeat(2, 1fr)',
            lg: 'repeat(4, 1fr)',
          },
          gap: { xs: 3, md: '40px' },
        }}
      >
        {aboutValues.map((value) => (
          <Box
            key={value.title}
            sx={{
              bgcolor: '#fffefa',
              borderRadius: '20px',
              boxShadow: '0px 0px 8px 0px rgba(0,0,0,0.12)',
              p: '24px',
              minHeight: { xs: 280, lg: 337 },
              boxSizing: 'border-box',
            }}
          >
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                gap: { xs: 6, lg: '50px' },
                height: '100%',
              }}
            >
              <FigmaIconFrame src={value.icon} bgColor={value.iconBgColor} />
              <Box sx={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
                <Typography
                  sx={{
                    fontSize: { xs: 22, md: 28 },
                    lineHeight: 'normal',
                    fontWeight: 400,
                    color: '#111',
                  }}
                >
                  {value.title}
                </Typography>
                <Typography
                  sx={{
                    fontSize: { xs: 16, md: 20 },
                    lineHeight: 'normal',
                    fontWeight: 400,
                    color: '#111',
                    opacity: 0.6,
                  }}
                >
                  {value.description}
                </Typography>
              </Box>
            </Box>
          </Box>
        ))}
      </Box>
    </Box>
  )
}
